<template>
  <v-dialog fullscreen scrollable
    v-model="config.status.active">
    <v-card class="grey lighten-4">
      <v-card-title class="transparency pb-0">
        <MitsuisumitomoHeader v-if="getBookCompany === 'mitsuisumitomo'" />
        <DcCardHeader v-else-if="getBookCompany === 'dc'" />
        <!-- <RakutenHeader v-else-if="getBookCompany === 'rakuten'" />
        <LifeCardHeader v-else-if="getBookCompany === 'life'" /> -->
        <v-progress-linear indeterminate :color="isLoading ? 'secondary' : 'transparent'" />
      </v-card-title>
      <v-card-text class="transparency">
        <Mitsuisumitomo v-if="!isLoading && getBookCompany === 'mitsuisumitomo'" :meta="meta" :items="getItems" />
        <DcCard v-else-if="!isLoading && getBookCompany === 'dc'" :meta="meta" :items="getItems" />
        <!-- <Rakuten v-else-if="!isLoading && getBookCompany === 'rakuten'" :items="getItems" />
        <LifeCard v-else-if="!isLoading && getBookCompany === 'life'" :items="getItems" /> -->
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn text color="secondary" @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <span v-if="!isLoading && isValid" class="d-flex red--text mr-2 caption">振り分け済の項目も削除されます</span>
        <span v-if="!isLoading && !isValid" class="d-flex red--text mr-2 caption">既に確定した会計項目があるので削除できません</span>
        <v-btn depressed
          color="red white--text"
          :loading="isLoading"
          :disabled="!isValid" @click="remove">削除する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MitsuisumitomoHeader from './components/mitsuisumitomo/header'
import Mitsuisumitomo from './components/mitsuisumitomo'
import DcCardHeader from './components/dc/header'
import DcCard from './components/dc'
export default {
  name: 'authorBbookRemove',
  props: [ ],
  components: {
    MitsuisumitomoHeader,
    Mitsuisumitomo,
    DcCardHeader,
    DcCard
  },
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false
        }
      },
      meta: {
        withdraws: [ 'payments', 'prefunds' ],
        labels: {
          deposites: '預り金',
          payments: '預り金',
          commissions: '預り金',
          prefunds: '預り金（返金）',
          drefunds: '預り金（返金）',
          dcpayments: '預り金',
          dcrefunds: '預り金（返金）'
        },
        type: {
          deposite: '入金',
          payment: '支払',
          commission: 'コミッション',
          prefund: '返金（支払）',
          drefund: '返金（入金）',
          dcpayment: '支払',
          dcrefunds: '返金'
        },
        items: {
          school: '学費',
          stay: '滞在費用',
          aviation: '航空券代金',
          avicom: '航空券変更手数料',
          insurance: '保険料',
          visa: '査証費用',
          domestic: '国内諸経費',
          hotel: 'ホテル代',
          apart: 'アパート代',
          support: '現地サポート代',
          test: 'テスト受験代',
          mobile: '携帯電話代',
          computer: 'パソコン代',
          examfee: '受験料',
          textfee: '参考書代',
          hospital: '病院診察代金',
          tour: '現地ツアー代',
          trafic: '現地交通代',
          shipping: '現地荷物発送費',
          uniform: '制服・スーツ代',
          carry: '繰越金',
          bank_handling: '銀行手数料'
        }
      },
      form: {
      },
      store: {
        type: '',
        company: '',
        item: {},
        entries: [],
        clients: {},
        cbooks: {}
      }
    }
  },
  methods: {
    open: function (req) {
      const { type, company, item } = req || {}
      if (type && item) {
        this.$set(this.store, 'type', type)
        this.$set(this.store, 'company', company)
        this.$set(this.store, 'item', item)
        this.$set(this.config.status, 'active', true)
        this.$nextTick(() => {
          this.submit({ type: 'preview' })
        })
      }
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    remove: function () {
      this.submit({ type: 'remove' })
    },
    preSubmit: function (req) {
      const { type } = req || {}
      const { item } = this.store
      const urls = {
        preview: `${this.$url.api}/bbook/preview/remove/media/${item.id}`,
        remove: `${this.$url.api}/bbook/remove/media/${item.id}`
      }
      const fds = {
        preview: {},
        remove: {}
      }
      if (type && urls[type] && fds[type]) {
        this.$set(this.config.status, 'loading', true)
        return { type, url: urls[type], fd: fds[type] }
      } else {
        return false
      }
    },
    submit: function (req) {
      const dt = this.preSubmit(req)
      if (dt) {
        const { url, fd, type } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit(res.data.data, type)
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req, submitType) {
      const type = submitType || ''
      if (type === 'preview') {
        const { entries, clients, cbooks } = req
        this.$set(this.store, 'entries', entries)
        this.$set(this.store, 'clients', clients)
        this.$set(this.store, 'cbooks', cbooks)
        this.$set(this.config.status, 'loading', false)
      } else if (type === 'remove') {
        this.$set(this.config.status, 'loading', false)
        this.$set(this.store, 'entries', [])
        this.close()
      } else if (type === 'download') {
        window.location.href = req
        this.$set(this.config.status, 'loading', false)
      }
    },
    failSubmit: function (req) {
      this.$set(this.config.status, 'loading', false)
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isValid () {
      const invalids = this.store.entries.length ? this.store.entries.filter(it => {
        const { children } = it
        const locked = children && children.length ? children.filter(it => {
          return (this.store.cbooks[it.cbook] && this.store.cbooks[it.cbook].flag === 'T')
        }) : []
        return locked.length
      }) : []
      return invalids.length === 0
    },
    getBookType () {
      return this.store.type
    },
    getBookCompany () {
      return this.store.company
    },
    getItems () {
      return this.store.entries.length ? this.store.entries.map(it => {
        const { id, cid, type, date, sum, label, children } = it
        const cl1 = this.store.clients[cid] || { name: '' }
        const locked = children && children.length ? children.filter(it => {
          return (this.store.cbooks[it.cbook] && this.store.cbooks[it.cbook].flag === 'T')
        }) : []
        return {
          id,
          date: this.$moment(date).format('YYYY/MM/DD'),
          withdraw: this.meta.withdraws.includes(type) ? `¥${`${sum}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}` : '',
          deposite: !this.meta.withdraws.includes(type) ? `¥${`${sum}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}` : '',
          client: cl1.name.replace(',', ' '),
          label: this.meta.labels[type] || '',
          sum: `¥${`${sum}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}`,
          item: this.meta.items[label] || '',
          status: locked.length ? 'locked' : 'active',
          children: (children && children.length) ? children.map(jt => {
            const cl2 = this.store.clients[jt.cid] || { name: '' }
            return {
              id: jt.id,
              type: jt.type,
              label: jt.label,
              date: this.$moment(jt.date).format('YYYY/MM/DD'),
              sum: `¥${`${jt.sum}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}`,
              client: cl2.name.replace(',', ''),
              cbook: this.store.cbooks[jt.cbook] || { title: '', flag: '' }
            }
          }) : []
        }
      }) : []
    }
  }
}
</script>